const hubspotFormBlock = document.querySelector('.hubspot-form-block');

export function init() {
	if (hubspotFormBlock) {
		document.addEventListener('input', function (event) {
			let evSrcEl = event.srcElement;
			let evTarget = event.target;
			if ((evTarget.tagName === 'SELECT' || evTarget.tagName === 'select') && evSrcEl.className === 'hs-input' && (evSrcEl.value !== '' || evSrcEl.value !== null)) {
				event.target.classList.add('hs-input--has-value');
			}
		});
	}
}

export default {
	init
};
